export default __webpack_public_path__ + "static/filing-aeb6fb38b02618b526cd340501db7a34.png";